export const MARKETPLACE_CATEGORIES = [
  {
    name: 'Drones',
    subcategories: [
      'Photography',
      'Surveying & mapping',
      'Inspection',
      'Agriculture',
    ],
  },
  {
    name: 'Drone accessories',
    subcategories: [
      'Cameras & payloads',
      'Batteries & power',
      'Parts & accessories',
    ],
  },
  { name: 'Furniture', subcategories: ['Chairs', 'Other furniture'] },
  {
    name: 'Computer equipment',
    subcategories: ['Computers', 'Peripherals & accessories'],
  },
  { name: 'Food & drink', subcategories: ['Food', 'Drinks'] },
  { name: 'Other', subcategories: ['General supplies'] },
] as const
